{
  "corporatePortal": {
    "corporateDetails": {
      "partnerServices": "Yhteistyökumppaneiden palvelut",
      "chooose": {
        "title": "Finnair for Business SAF-palvelu",
        "tag": {
          "notAdmin": "Tarjolla vain ylläpitäjille",
          "available": "Saatavilla",
          "notActivated": "Ei aktivoitu"
        },
        "viewEmissions": "Seuraa päästöjäsi",
        "activate": "Aktivoi"
      }
    },
    "widgets": {
      "safWidget": {
        "activated": {
          "title": "Seuraa ja vähennä päästöjäsi",
          "description": "Nyt voit seurata yrityksesi liikematkustamisesta syntyviä päästöjä ja hankkia SAF-ympäristöartribuutteja, joilla voit pienentää yrityksesi hiilijalanjälkeä."
        },
        "notActivated": {
          "title": "Aloita päästöjen seuranta",
          "description": "Aloita vähentämään yrityksesi CO₂-päästöjä seuraamalla liikematkustamisesta syntyviä päästöjä ja tukemalla uusituvan lentopolttoaineen käyttöä. Liity Finnair for Business SAF-palveluun, niin pääset alkuun!"
        },
        "readMore": "Lue lisää",
        "activate": "Aloita",
        "viewEmissions": "Seuraa päästöjäsi",
        "activateModalTitle": "Ota käyttöön Finnair for Business SAF-palvelu",
        "activateButtonForCompany": "Aktivoi palvelu yrityksellesi",
        "activateButtonForUser": "Aktivoi tilisi",
        "sustainabilityServicesForCompany": "Mikä on SAF-palvelu?",
        "sustainabilityServicesTextForCompany": "<p class=\"ms-medium-b\">Finnair tarjoaa yhdessä Chooosen kanssa palvelun, jossa voit seurata työntekijöidesi lentopäästöjä ja pienentää yrityksesi hiilipäästöjä osallistumalla uusituvan lentopolttoaineen (SAFin) hankintaan.</p><p class=\"ms-medium-b\">Aloita aktivoimalla palvelu yrityksellesi. Aktivointiin sinun tulee olla yritystilin ylläpitäjä.</p>",
        "sustainabilityServicesForUser": "Mikä on SAF-palvelu?",
        "sustainabilityServicesTextForUser": "<p class=\"ms-medium-b\">Finnair tarjoaa yhdessä Chooosen kanssa palvelun, jossa voit seurata työntekijöidesi lentopäästöjä ja pienentää yrityksesi hiilipäästöjä osallistumalla kestävän lentopolttoaineen (SAFin) hankintaan.</p><p class=\"ms-medium-b\">Voit nyt aktivoida oman käyttäjätilisi. Tilin ylläpitäjät pääsevät palveluun Finnair for Business -portaalin kautta.</p>",
        "howItWorks": "Näin se toimii:",
        "howItWorksOptions": [
          "Yrityksesi päästöt lasketaan työntekijöidesi lentojen perustella, kun lentojen varaamiseen on käytetty yrityksen Finnair for Business -tunnusta.",
          "Voit tarkkailla päästömääriä ja hankkia SAF-ympäristöattribuutteja, joilla pienennät yrityksesi hiilijalanjälkeä.",
          "Saat hankinnoista SAF sertifikaatin, jota voit käyttää raportoinnissa."
        ],
        "acceptTerms": {
          "label": "Olen lukenut ja hyväksyn, miten Finnair kerää ja käsittelee henkilötietojasi. Lue lisää",
          "linkText": "Finnairin tietosuojaselosteesta.",
          "required": "Hyväksy käyttäjäehdot jatkaaksesi"
        },
        "credentialsModalTitle": "Ota käyttöön Finnair for Business SAF-palvelu",
        "checkYourEmail": "Tarkista sähköpostisi",
        "checkYourEmailText": "Yhteistyökummpanimme Chooose on lähettänyt sinulle kutsun osoitteeseen: {email}. Klikkaamalla linkkiä pääset aktivoimaan tilisi."
      }
    },
    "redirectingToPartnerSite": "Sinut ohjataan Finnair for Business SAF-yhteistyökumppanin sivulle",
    "redirectDescription": "Finnair for Business SAF-palvelun toimittaa Chooose, jonka kanssa voimme auttaa sinua samaan aikaan sertifioituja päästövähennyksiä.",
    "navigation": "Finnair for Business valikko"
  }
}
